import React from 'react';
import { BoltIcon, EnvelopeIcon, MagnifierIcon, MicrophoneIcon } from './icons';
import {
  ActionButtonContainer,
  CreatePendingPatientContextButton,
  FlexEndWrapper,
  HeaderIconButton,
  OpenZoomButton
} from './common';

export const PendingPatientContextActions = () => (
  <FlexEndWrapper>
    <ActionButtonContainer>
      <HeaderIconButton disabled icon={<BoltIcon />} />
      <HeaderIconButton disabled icon={<MagnifierIcon />} />
      {/*<HeaderIconButton disabled icon={<BookmarkIcon />} />*/}
      {/*<HeaderIconButton disabled icon={<FireIcon />} />*/}
      <OpenZoomButton />
      {/*<HeaderIconButton disabled icon={<ChatIcon />} />*/}
      <HeaderIconButton disabled icon={<MicrophoneIcon />} />
      <HeaderIconButton disabled icon={<EnvelopeIcon />} />
      <CreatePendingPatientContextButton />
    </ActionButtonContainer>
  </FlexEndWrapper>
);
